var map = {
	"./components/UxGuide/UxGuidelines/examples/accessibility-bad.png": 23901,
	"./components/UxGuide/UxGuidelines/examples/accessibility-good.png": 78670,
	"./components/UxGuide/UxGuidelines/examples/alignment-bad.png": 96908,
	"./components/UxGuide/UxGuidelines/examples/alignment-good.png": 87240,
	"./components/UxGuide/UxGuidelines/examples/loading-bad.png": 6030,
	"./components/UxGuide/UxGuidelines/examples/loading-good.png": 44041,
	"./components/UxGuide/UxGuidelines/examples/onboarding-bad.png": 67510,
	"./components/UxGuide/UxGuidelines/examples/onboarding-good.png": 33347,
	"./components/UxGuide/UxGuidelines/examples/onboarding-sidebar-bad.png": 83595,
	"./components/UxGuide/UxGuidelines/examples/onboarding-sidebar-good.png": 56369,
	"./components/UxGuide/UxGuidelines/examples/performance-bad.png": 81935,
	"./components/UxGuide/UxGuidelines/examples/performance-good.png": 62376,
	"./components/UxGuide/UxGuidelines/examples/theme-bad.png": 34412,
	"./components/UxGuide/UxGuidelines/examples/theme-good.png": 19891,
	"./components/UxGuide/UxGuidelines/useThinkFeel.png": 32451,
	"./resources/images/Octopus-96x96.png": 4994,
	"./resources/images/octo-surfer-200.png": 5420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56578;